const FOCUSABLE_SELECTOR = [
  "a[href]",
  "button:not([disabled])",
  "input:not([disabled]):not([type='hidden'])",
  "select:not([disabled])",
  "textarea:not([disabled])",
  "iframe",
  "[tabindex]",
].join(", ");

// What Tab can reach inside a container, in order, for keeping focus inside a
// dialog or the mobile nav drawer. A roving group (the day strip) keeps all but
// one of its buttons at tabIndex -1, so those are left out too.
export const tabbableIn = (container) =>
  Array.from(container.querySelectorAll(FOCUSABLE_SELECTOR)).filter(
    (element) => element.tabIndex >= 0 && !element.closest("[hidden], [inert]"),
  );
